import React from "react";
import { Code, ScrollArea } from "@mantine/core";

const SECRET_KEY = /pass(word|phrase)|secret|token/i;

const withoutSecrets = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(withoutSecrets);
  if (!value || typeof value !== "object") return value;
  return Object.fromEntries(
    Object.entries(value as Record<string, unknown>)
      .filter(([key]) => !SECRET_KEY.test(key))
      .map(([key, nested]) => [key, withoutSecrets(nested)]),
  );
};

interface Props {
  value: unknown;
  maxHeight?: number;
}

const ConfigJsonView: React.FC<Props> = ({ value, maxHeight = 320 }) => (
  <ScrollArea.Autosize mah={maxHeight} type="auto">
    <Code block style={{ background: "var(--oculera-surface-alt)" }}>
      {JSON.stringify(withoutSecrets(value) ?? {}, null, 2)}
    </Code>
  </ScrollArea.Autosize>
);

export default ConfigJsonView;
